<template>
    <div class="RePromptEditor">
        <v-btn icon small @click="addRePrompt($event)" v-if="itemList.length === 0">
            <v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-layout>
            <v-select
                v-if="mode === 'view'"
                :items="itemList"
                item-text="name"
                item-value="name"
                class="mb-2 ScenarioSelect"
                v-model="tab"
                hide-details
                dense
            ></v-select>
            <ScenarioInput
                v-else
                style="flex: 1 1 10px"
                class="mb-2"
                v-model="rePromptName"
                :editable="true"
                @focusout="updateRePromptName($event)"
                ref="name"
            ></ScenarioInput>
            <template v-if="isEditable">
                <v-btn icon small @click="renameRePrompt" class="mr-0" :disabled="mode !== 'view'">
                    <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon small @click="removeRePrompt" class="mr-0" :disabled="mode !== 'view'">
                    <v-icon small>mdi-delete</v-icon>
                </v-btn>
                <v-btn icon small @click="addRePrompt" v-show="mode === 'view'">
                    <v-icon small>mdi-plus</v-icon>
                </v-btn>
                <v-btn icon small v-show="mode !== 'view'">
                    <v-icon small>mdi-check</v-icon>
                </v-btn>
            </template>
        </v-layout>
        <PromptEditor v-model="rePrompt.prompt" @save="save"></PromptEditor>
        <ConditionEditor ref="ConditionEditor" :items.sync="rePrompt.conditionList" @save="save"></ConditionEditor>
    </div>
</template>

<script>
import ConditionEditor from '@/views/Scenario/NodeEditor/common/ConditionEditor'
import ScenarioService from '@/services/scenario.service'
import { mapState } from 'vuex'
import ScenarioInput from '@/views/Scenario/components/ScenarioInput'
import PromptEditor from '@/views/Scenario/NodeEditor/kb/PromptEditor'

export default {
    name: 'RePromptEditor',
    components: { PromptEditor, ScenarioInput, ConditionEditor },
    props: {
        items: Array
    },
    data () {
        return {
            tab: '',
            itemList: [],
            rePrompt: {},
            mode: 'view',
            rePromptName: ''
        }
    },
    computed: {
        ...mapState({
            isEditable: () => ScenarioService.isEditable()
        })
    },
    methods: {
        addRePrompt () {
            this.mode = 'add'
            this.rePromptName = ''
            this.$nextTick(() => {
                this.$refs.name.$el.focus()
            })
        },
        renameRePrompt () {
            this.mode = 'edit'
            this.rePromptName = this.rePrompt.name
            this.$nextTick(() => {
                this.$refs.name.$el.focus()
            })
        },
        async removeRePrompt () {
            let confirmed = await this.$appService.confirm(this.$t('confirmDelete', { item: this.tab }))
            if (!confirmed) {
                return
            }
            for (let i = 0; i < this.itemList.length; i++) {
                if (this.itemList[i].name === this.tab) {
                    this.itemList.splice(i, 1)
                }
            }
            if (this.itemList.length > 0) {
                this.tab = this.itemList[0].name
            } else {
                this.tab = ''
            }
            this.$nextTick(this.save)
        },
        save () {
            this.$emit('save')
        },
        updateRePromptName (name) {
            this.rePromptName = name
            if (this.rePromptName) {
                if (this.itemList.find(item => item.name === this.rePromptName)) {
                    this.$appService.toastError('RePrompt name already exist')
                    this.mode = 'view'
                    return
                }
                if (this.mode === 'add') {
                    this.itemList.push({
                        name: this.rePromptName,
                        prompt: 'content ' + this.rePromptName,
                        conditionList: [[]]
                    })
                } else {
                    this.rePrompt.name = this.rePromptName
                }
                this.tab = this.rePromptName
                this.save()
            }
            this.mode = 'view'
            this.$forceUpdate()
        }
    },
    watch: {
        items: {
            immediate: true,
            handler: function (items) {
                this.itemList = items ? items : []
                if (this.itemList.length > 0) {
                    if (this.tab) {
                        this.rePrompt = this.itemList.find(item => item.name === this.tab)
                        if (!this.rePrompt) {
                            this.tab = ''
                        }
                    }
                    if (!this.tab) {
                        this.tab = this.itemList[0].name
                        this.rePrompt = this.itemList[0]
                    }
                }
            }
        },
        itemList: {
            deep: true,
            handler () {
                this.$emit('update:items', this.itemList)
            }
        },
        tab () {
            this.rePrompt = {
                prompt: ''
            }
            this.$forceUpdate()
            this.$nextTick(() => {
                this.rePrompt = this.itemList.find(item => item.name === this.tab)
            })


        }
    }
}
</script>

<style scoped lang="scss">
    .tab-name-editor {
        background: #fff;
        color: #000;
    }

    .tab-title-container {
        display: flex;
        border-bottom: 3px solid #0052CC;
        padding: 0 21px;
        position: relative;

        .move-active {
            position: absolute;
            top: 5px;

            &.left {
                left: 0
            }

            &.right {
                right: 0;
            }
        }
    }

    .tab-title {
        width: 156px;
        height: 27px;
        background: #B2B4C6;
        border-radius: 5px 5px 0 0;
        margin-right: 5px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        color: #fff;

        &.active {
            background: #0052CC;
        }
    }

    .add-tab {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #B2B4C6;
        border-radius: 5px 5px 0 0;
        width: 27px;
    }

    .RePromptEditor::v-deep {
        .v-tabs .v-tabs__bar {
            border-bottom: 2px solid #0052CC;

            .v-tabs__container {
                min-height: 30px;
            }
        }

        .v-tabs__icon {
            font-size: 16px;
            width: 36px;
        }

        .v-tabs .v-tabs__bar .v-tabs__item {
            font-weight: normal;
            font-size: 14px;
            padding: 0 10px;
            background: #B2B4C6;
            color: #fff;
            /*width: 156px;*/

            &.v-tabs__item--active {
                background: #0052CC;

                i {
                    color: #B2B4C6;
                }
            }
        }
    }
    .ScenarioSelect {
        height: 32px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 1px solid #D9D9D9;
        outline: none;
        font-size: 14px;
        padding: 6px 12px;
        margin: 0;
        display: flex;
        align-items: center;

        &.v-input--is-focused {
            border-color: #00a2b9;
        }

        ::v-deep * {
            &:before, &:after {
                border: none !important;
            }

            .v-select__selections {
                white-space: nowrap;
            }
        }
    }
</style>
